import EfCouponTop from '../ef-coupon-top';
import EfModal from '../ef-modal';

export default function EfCouponCardModal({
    prefixCls,
    open,
    callback,
    TextA,
    noteList = [],
    sqlItemData = {},
}: {
    prefixCls?: string;
    open: boolean;
    callback?: any;
    TextA?: any;
    noteList?: any[];
    sqlItemData?: any;
}) {
    return (
        <EfModal open={open} callback={callback} className="ef-check-in-activities-coupon-win ef-coupon-card-rules-win">
            <EfCouponTop sqlItemData={sqlItemData} />
            <div className={`${prefixCls}-win-rules-h`}>{TextA?.rules}</div>
            <ul className={`${prefixCls}-win-rules-c`}>
                {noteList?.map((item: any, index: number) => {
                    return (
                        <li className={`${prefixCls}-win-rules-item`} key={index}>
                            {item}
                        </li>
                    );
                })}
            </ul>
        </EfModal>
    );
}
